import { Trans, useTranslation } from 'react-i18next'
import Sheet from '../../components/Sheet'
import ActionBar from '../../components/ActionBar'
import Typography from '@mui/material/Typography'

export default function ConfirmDeleteUser(props) {
    const { t } = useTranslation()
    const { showDeleteUser, setShowDeleteUser, fetchResource, targetUser } = props

    async function handleSubmit() {
        if (targetUser === 'dandelim') {
            return setShowDeleteUser(false)
        }

        try {
            await fetchResource({
                resource: 'users/delete',
                body: { username: targetUser },
                blocking: true
            })
            window.location.reload(false)
            setShowDeleteUser(false)
        } catch (error) {
            console.error(error)
            alert(error)
        }
    }
    return (
        showDeleteUser && (
            <Sheet
                open={showDeleteUser}
                onClose={() => setShowDeleteUser(false)}
                title={t('users.deleteTitle')}
                actions={
                    /* This dialog used to offer exactly one button -- Delete -- with
                       the backdrop and Esc as its only unsignposted way out. */
                    <ActionBar
                        cancel={{ label: t('common.cancel'), onClick: () => setShowDeleteUser(false) }}
                        confirm={{ label: t('common.delete'), onClick: handleSubmit, tone: 'danger' }}
                    />
                }
            >
                <Typography>
                    <Trans i18nKey='users.confirmDeleteMessage' values={{ username: targetUser }} components={{ b: <b /> }} />
                </Typography>
            </Sheet>
        )
    )
}
